import { connect } from 'react-redux';

// action creators
import { sessionCreate } from '../../actions/sessionActions';

// components
import Login from './Login';

const mapStateToProps = state => ({
  form: state.get('form'),
});

const mapDispatchToProps = dispatch => ({
  createSession: (params) => {
    dispatch(sessionCreate(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
